<script>
    export let fill = '#FFF'
</script>

<style>
    svg {
        position: absolute;
        top: 343px;
        left: 11px;
        width: 395px;
    }
</style>

<svg id="sponsor-label" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1112.9 72.5">
    <g>
        <path {fill} d="M0,72.5V12C0,5.4,5.4,0,12,0H1100.9c6.6,0,12,5.4,12,12v60.5H0Z"/>
    </g>
</svg>